module.exports = __webpack_public_path__ + "img/welfare-btn-bg.312bbc2f.png";